module.exports = __webpack_public_path__ + "static/img/31.3445c45b.png";